import React from 'react'
import { useStyles } from './styles'
import maxBy from 'lodash/maxBy'
import { Chart } from '@devexpress/dx-react-chart-material-ui'
import MilestoneIcon from '../../../../Icons/MilestoneIcon'
import { CHART_COLOR_PALETTE_BY_LEVEL, PACE_COLOR_PALETTE } from '../../../../../constants/theme'

const getPath = (x, width, y, y1) => `M ${x} ${y1}
   L ${width + x} ${y1}
   L ${width + x} ${y}
   L ${x + width / 2} ${y}
   L ${x} ${y}
   Z`

const getBarColor = (barIndex, chartData, value) => {
  const level = chartData.find(el => el.offset === barIndex + 1)
  if (level.pace && value) {
    return PACE_COLOR_PALETTE[level.pace]
  }
  return CHART_COLOR_PALETTE_BY_LEVEL[level.levelIndex - 1]
}

const getLevelIndex = (barIndex, chartData) => {
  const level = chartData.find(el => el.offset === barIndex + 1)
  const highestStepOnCurrentLevel = maxBy(
    chartData.filter(el => el.levelIndex === level.levelIndex),
    'stepIndex'
  ).stepIndex

  if (Math.ceil(highestStepOnCurrentLevel / 2) === level.stepIndex) {
    return level.levelIndex
  }
  return ''
}

const Bar = ({ arg, barWidth, val, startVal, style, index, chartData, nextMilestoneStepIndex, value }) => {
  const width = 16 * barWidth
  const classes = useStyles()

  return (
    <React.Fragment>
      <path
        d={getPath(arg - width / 2, width, val === startVal ? val - 6 : val, startVal)}
        fill={getBarColor(index, chartData, value)}
        style={style}
        opacity={value === 0 ? '0.3' : 1}
      />
      {nextMilestoneStepIndex === index ? <line x1={arg} y1={val} x2={arg} y2={0} stroke='red' strokeDasharray='3' /> : null}
      <Chart.Label
        x={arg + width / 1.5}
        y={240}
        dominantBaseline='middle'
        textAnchor='middle'
        style={{
          fill: '#8688A1',
          fontFamily: 'National',
          fontSize: '10px'
        }}
        className={classes.label}
      >
        {getLevelIndex(index, chartData)}
      </Chart.Label>
      {nextMilestoneStepIndex === index ? <MilestoneIcon x={arg + width / 1.5 - 16} y={230} /> : null}
    </React.Fragment>
  )
}

export default Bar
